import { ProductNameClient } from "../../../../../../../../Wrap/Api/Account/ProductName";
import { ProductOverviewClient } from "../../../../../../../../Wrap/Api/Account/ProductOverview";
import { PersonalDetailClient } from "../../../../../../../../Wrap/Api/Customer/PersonalDetail";
import { RetirementDateClient } from "../../../../../../../../Wrap/Api/Customer/RetirementDate";
import { AccountStatus } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { IJsonDate } from "../../../../../../../../Wrap/System/IJsonDate";

export class ProductOverviewProductInformationAction {
    public static getProductInformation(hierarchyId: string, callback) {
        const client = new ProductOverviewClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((data) => callback(data));

        promise.onError(() => {});
    }

    public static updateProductName(hierarchyid: string, name: string, callback) {
        const client = new ProductNameClient();
        const promise = client.put(hierarchyid, name);

        promise.onSuccess((data) => callback(data));

        promise.onError(() => {});
    }

    public static saveProductInformation(hierarchyId: string, name: string, accountStatus: AccountStatus, callback) {
        const client = new ProductOverviewClient();
        const promise = client.put(hierarchyId, name, accountStatus);

        promise.onSuccess((data) => callback(data));

        promise.onError(() => {});
    }

    public static getDateOfBirth(customerId: number, callback){
        const client = new PersonalDetailClient();
        const promise = client.get(customerId);

        promise.onSuccess((data) => callback(data?.DateOfBirth));
        promise.onError(() => {});

    }

    public static saveRetirementDate(customerId: number, retirementDate: IJsonDate, callback){
        const client = new RetirementDateClient();
        const promise = client.put(customerId, retirementDate);

        promise.onSuccess(() => callback());
        promise.onError(() => {});
    }
}
